"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[6357],{

/***/ 36937:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(12132);

var _interopRequireWildcard = __webpack_require__(78242);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(93236));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(79302));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'PersonAdd');

exports.Z = _default;

/***/ }),

/***/ 86377:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(12132);

var _interopRequireWildcard = __webpack_require__(78242);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(93236));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(79302));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.Z = _default;

/***/ }),

/***/ 64244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ActionBar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/PersonAdd.js
var PersonAdd = __webpack_require__(36937);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(86377);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/patient-queue-management/links.ts
var links = __webpack_require__(32780);
// EXTERNAL MODULE: ./src/client/ward-patient-list/links.ts
var ward_patient_list_links = __webpack_require__(55036);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(97754);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
;// CONCATENATED MODULE: ./src/client/clinician/ActionButton.tsx





const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  link: {
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    display: "flex"
  },
  buttonText: {
    fontSize: 12,
    color: theme.palette.grey[600]
  },
  activeButtonText: {
    color: theme.palette.primary.main
  }
}));
const LinkButton = (0,styled/* default */.Z)(mui_button_dist_module/* LinkButton */.Qj)(({ theme }) => ({
  border: "none",
  borderRadius: 0,
  color: theme.palette.grey[600],
  height: "100%",
  [theme.breakpoints.down("xs")]: {
    margin: "0",
    minWidth: "auto"
  },
  minWidth: "100%"
}));
const ActionButtonText = ({
  children,
  isActive
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classnames_default()(classes.buttonText, {
      [classes.activeButtonText]: isActive
    })
  }, children);
};
const ActionButton = ({
  Icon,
  isActive,
  text,
  ...props
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(LinkButton, {
    replace: false,
    variant: "text",
    linkClassName: classes.link,
    ...props
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column"
  }, Icon ? /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Icon, {
    fontSize: "large",
    color: isActive ? "primary" : "inherit"
  })) : null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(ActionButtonText, {
    isActive
  }, text))));
};
/* harmony default export */ const clinician_ActionButton = (ActionButton);

// EXTERNAL MODULE: ./src/client/clinician/links.tsx
var clinician_links = __webpack_require__(65460);
// EXTERNAL MODULE: ./src/client/components/GlobalAppIssueOverlay/SafetySpace.tsx
var SafetySpace = __webpack_require__(18747);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/index.ts + 5 modules
var uxAnalytics = __webpack_require__(62463);
// EXTERNAL MODULE: ./src/client/new/tracing.ts
var tracing = __webpack_require__(29859);
// EXTERNAL MODULE: ./src/client/patient-search/links.ts
var patient_search_links = __webpack_require__(87268);
// EXTERNAL MODULE: ./src/client/new/links.ts
var new_links = __webpack_require__(81222);
;// CONCATENATED MODULE: ./src/client/clinician/ActionBar.tsx
















var Buttons = /* @__PURE__ */ ((Buttons2) => {
  Buttons2["addPatient"] = "addPatient";
  Buttons2["wards"] = "ward";
  Buttons2["queuing"] = "queuing";
  Buttons2["findPatient"] = "findPatient";
  Buttons2["scanCard"] = "scanCard";
  return Buttons2;
})(Buttons || {});
function getToolbarHeightRules(theme, cssProp = "top") {
  return Object.entries(theme.mixins.toolbar).reduce(
    (acc, [k, v]) => {
      if (k.startsWith("@")) {
        acc[k] = { [cssProp]: v.minHeight };
      }
      return acc;
    },
    {
      [cssProp]: theme.mixins.toolbar.minHeight
    }
  );
}
const getActiveButton = (pathname) => {
  switch (pathname) {
    case (0,new_links/* linkToNewPatient */.OF)():
      return "addPatient" /* addPatient */;
    case (0,ward_patient_list_links/* linkToWardPatientList */.P)():
      return "ward" /* wards */;
    case (0,links/* linkToPatientQueue */.b)():
      return "queuing" /* queuing */;
    case (0,patient_search_links/* linkToPatientSearch */.O)():
      return "findPatient" /* findPatient */;
    case (0,clinician_links/* linkToScanCard */.eH)():
      return "scanCard" /* scanCard */;
    default:
      return null;
  }
};
const Container = (0,styled/* default */.Z)("div")(({ theme }) => ({
  position: "fixed",
  right: 0,
  bottom: 0,
  backgroundColor: theme.palette.grey[100],
  gap: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    ...getToolbarHeightRules(theme, "top"),
    flexDirection: "column"
  },
  [theme.breakpoints.down("xs")]: {
    flexDirection: "row"
  },
  width: "inherit",
  display: "flex",
  justifyContent: "center",
  alignContent: "center"
}));
const ActionBar_ActionButton = (0,styled/* default */.Z)(clinician_ActionButton)({
  flex: 1
});
const GaplessGlobalAppIssueSafetySpace = (0,styled/* default */.Z)(SafetySpace/* default */.Z)(
  ({ theme }) => ({
    marginRight: -theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  })
);
const ClinicianActionBar = () => {
  const location = (0,dist/* useLocation */.TH)();
  const activeButton = getActiveButton(location.pathname);
  const { startSpan, addEventToSpan } = (0,uxAnalytics/* useTracing */.kz)();
  return /* @__PURE__ */ react.createElement(Container, null, /* @__PURE__ */ react.createElement(GaplessGlobalAppIssueSafetySpace, null), /* @__PURE__ */ react.createElement(ActionBar_ActionButton, {
    isActive: activeButton === "addPatient" /* addPatient */,
    to: (0,new_links/* linkToNewPatient */.OF)(),
    onClick: () => {
      startSpan(tracing/* AddNewPatientTracingSpans.ROOT */.f.ROOT, { root: true });
      addEventToSpan(
        tracing/* AddNewPatientTracingEvents */.z[tracing/* AddNewPatientTracingSpans.ROOT */.f.ROOT].BEGIN
      );
    },
    Icon: PersonAdd/* default */.Z,
    text: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "clinician-action.button-text.addPatient",
      defaultMessage: "Add Patient"
    }),
    "data-testid": "clinician-action-bar-add-patient-button"
  }), /* @__PURE__ */ react.createElement(ActionBar_ActionButton, {
    isActive: activeButton === "ward" /* wards */,
    to: (0,ward_patient_list_links/* linkToWardPatientList */.P)(),
    Icon: dist_module.WardBedIcon,
    text: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "clinician-action.button-text.wards",
      defaultMessage: "Wards"
    }),
    "data-testid": "clinician-action-bar-ward-button"
  }), /* @__PURE__ */ react.createElement(ActionBar_ActionButton, {
    isActive: activeButton === "queuing" /* queuing */,
    to: (0,links/* linkToPatientQueue */.b)(),
    Icon: dist_module.QueuingIcon,
    text: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "clinician-action.button-text.queuing",
      defaultMessage: "Queuing"
    }),
    "data-testid": "clinician-action-bar-queuing-button"
  }), /* @__PURE__ */ react.createElement(ActionBar_ActionButton, {
    isActive: activeButton === "findPatient" /* findPatient */,
    to: (0,patient_search_links/* linkToPatientSearch */.O)(),
    Icon: Search/* default */.Z,
    text: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "clinician-action.button-text.find-patient",
      defaultMessage: "Find Patient"
    }),
    "data-testid": "clinician-action-bar-find-patient-button"
  }), /* @__PURE__ */ react.createElement(ActionBar_ActionButton, {
    isActive: activeButton === "scanCard" /* scanCard */,
    to: (0,clinician_links/* linkToScanCard */.eH)(),
    Icon: dist_module.ElephantCardIcon,
    text: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "clinician-action.button-text.scan-card",
      defaultMessage: "Scan Card"
    }),
    "data-testid": "clinician-action-bar-scan-card-button"
  }));
};
/* harmony default export */ const ActionBar = (ClinicianActionBar);


/***/ }),

/***/ 22102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ clinician_ScanPatientCardPage),
  "extractPassportIdFromQrCode": () => (/* binding */ extractPassportIdFromQrCode)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./src/client/patient/links.ts
var links = __webpack_require__(90806);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var mui_page_dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./src/client/components/CardInput/CardNumberInputForm.tsx + 1 modules
var CardNumberInputForm = __webpack_require__(65787);
;// CONCATENATED MODULE: ./src/client/clinician/FindByPassportId.tsx



function FindByPassportId(props) {
  const { loading, setPassportId } = props;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const onSubmit = (values) => {
    setPassportId(`${values.cardId}`);
  };
  return /* @__PURE__ */ react.createElement(CardNumberInputForm/* CardNumberInputForm */.P, {
    handleSubmit: onSubmit,
    placeholder: formatMessage({
      id: "clinician.dashboard.passportId.placeholder",
      defaultMessage: "Find patient by ID number"
    }),
    loading
  });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var mui_toast_dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./src/client/components/Layout/Header/ClinicianHeader.tsx
var ClinicianHeader = __webpack_require__(72520);
// EXTERNAL MODULE: ./src/client/components/Layout/Body.tsx
var Body = __webpack_require__(99589);
// EXTERNAL MODULE: ./src/client/clinician/ActionBar.tsx + 1 modules
var ActionBar = __webpack_require__(64244);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/clinician/__generated__/ScanPatientCardPage.gql.ts


const defaultOptions = {};
const FindPatientByPassportDocument = lib/* gql */.Ps`
    query findPatientByPassport($input: PatientByPassportInput!) {
  patientByPassport(input: $input) {
    _id
    uuid
    education {
      isStudent
      school
      nemisNumber
    }
    insurance {
      insuranceType
      insuranceNumber
      paymentUpToDate
      expiryDate
    }
    person {
      name {
        firstname
        middlename
        lastname
      }
      gender
      dob
      addresses {
        country
        state
        subCounty
        ward
        street
      }
      nationality
    }
    organisation
    clinic
  }
}
    `;
function useFindPatientByPassportQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(FindPatientByPassportDocument, options);
}
function useFindPatientByPassportLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(FindPatientByPassportDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/QrScanner/QrScanner.tsx + 2 modules
var QrScanner = __webpack_require__(95751);
// EXTERNAL MODULE: ./node_modules/.pnpm/jsqr@1.2.0/node_modules/jsqr/dist/jsQR.js
var jsQR = __webpack_require__(4099);
var jsQR_default = /*#__PURE__*/__webpack_require__.n(jsQR);
;// CONCATENATED MODULE: ./src/client/clinician/ScanPatientCardPage.tsx



















lib/* gql */.Ps`
  query findPatientByPassport($input: PatientByPassportInput!) {
    patientByPassport(input: $input) {
      _id
      uuid
      education {
        isStudent
        school
        nemisNumber
      }
      insurance {
        insuranceType
        insuranceNumber
        paymentUpToDate
        expiryDate
      }
      person {
        name {
          firstname
          middlename
          lastname
        }
        gender
        dob
        addresses {
          country
          state
          subCounty
          ward
          street
        }
        nationality
      }
      organisation
      clinic
    }
  }
`;
const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  root: {
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("xs")]: {
      width: "90%"
    }
  }
}));
function extractPassportIdFromQrCode(imageData) {
  const code = jsQR_default()(imageData.data, imageData.width, imageData.height);
  const wholeUrl = code == null ? void 0 : code.data;
  if (wholeUrl == null ? void 0 : wholeUrl.includes("signin")) {
    const trimmedUrl = wholeUrl.trim();
    const n = trimmedUrl.lastIndexOf("/");
    const text = trimmedUrl.substring(n + 1);
    return text;
  }
  return (wholeUrl == null ? void 0 : wholeUrl.trim()) || null;
}
const ScanPatientCardPage = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const classes = useStyles();
  const navigate = (0,dist/* useNavigate */.s0)();
  const searchWholeTerritory = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const [passportId, setPassportId] = react.useState(null);
  const [submittingText, setSubmittingText] = react.useState(null);
  const { loading } = useFindPatientByPassportQuery({
    skip: !passportId,
    onCompleted: (data) => {
      if (data.patientByPassport !== null) {
        const {
          patientByPassport: { uuid }
        } = data;
        navigate((0,links/* linkToPatientDetails */.V)({ patientUuid: uuid }));
        return;
      }
      mui_toast_dist_default().error(
        formatMessage({
          defaultMessage: "Couldn't find patient",
          id: "ScanPatientCardPage.findPatient.error"
        })
      );
      setPassportId(null);
      setSubmittingText(false);
      return;
    },
    onError: () => {
      mui_toast_dist_default().error(
        formatMessage({
          id: "ScanPatientCardPage.findPatient.error2",
          defaultMessage: "Could not find patient."
        })
      );
      setPassportId(null);
      setSubmittingText(false);
    },
    variables: { input: { id: passportId, searchWholeTerritory } }
  });
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(ClinicianHeader/* default */.Z, null), /* @__PURE__ */ react.createElement(Body/* default */.Z, {
    rightContent: /* @__PURE__ */ react.createElement(ActionBar/* default */.Z, null)
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    className: classes.root,
    p: 2
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pb: 1.5
  }, /* @__PURE__ */ react.createElement(mui_page_dist.PageTitle, {
    variant: "h4"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "clinician.scanPatientCard.title",
    defaultMessage: "Scan Card"
  }))), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(QrScanner/* QrScanner */.h, {
    onCapture: setPassportId,
    extractDataFromQrCode: extractPassportIdFromQrCode,
    isSubmittingViaTextInput: submittingText
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mt: 2
  }, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mt: 2
  }, /* @__PURE__ */ react.createElement(FindByPassportId, {
    setPassportId: (val) => {
      setSubmittingText(true);
      setPassportId(val);
    },
    loading
  })))));
};
/* harmony default export */ const clinician_ScanPatientCardPage = (ScanPatientCardPage);


/***/ }),

/***/ 65787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ CardNumberInputForm)
});

// UNUSED EXPORTS: stripNonDigits

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.7.2/node_modules/prop-types/index.js
var prop_types = __webpack_require__(19036);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
;// CONCATENATED MODULE: ./src/client/forms/ErrorMessage.jsx



const useErrorMessageStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  root: {
    display: "block",
    color: theme.palette.error.main,
    transform: ({ children }) => !children && `translateY(-${theme.spacing(2)}px)`,
    transition: theme.transitions.create(["all"]),
    position: "relative",
    zIndex: -1,
    height: 0,
    marginTop: ({ children }) => !children && "-4px"
  }
}));
const ErrorMessage = ({ children }) => {
  const classes = useErrorMessageStyles({ children });
  return /* @__PURE__ */ react.createElement("span", {
    className: classes.root
  }, children);
};
ErrorMessage.propTypes = {
  children: (prop_types_default()).node
};
ErrorMessage.defaultProps = {
  children: null
};
/* harmony default export */ const forms_ErrorMessage = (ErrorMessage);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
;// CONCATENATED MODULE: ./src/client/components/CardInput/CardNumberInputForm.tsx







const SearchFieldComponent = (props, ref) => /* @__PURE__ */ react.createElement(mui_input_dist_module/* SearchField */.Um, {
  ...props,
  inputRef: ref
});
const SearchField = react.forwardRef(SearchFieldComponent);
const validationSchema = es.object({
  cardId: es.string().required().min(
    12,
    (0,lib/* defineMessage */.Em)({
      id: "card.activate.minLength",
      defaultMessage: "The number is too short"
    })
  ).max(
    12,
    (0,lib/* defineMessage */.Em)({
      id: "card.activate.maxLength",
      defaultMessage: "The number is too long"
    })
  )
});
const stripNonDigits = (input) => input == null ? void 0 : input.replace(/\D/gi, "");
const CardNumberInputForm = ({
  placeholder = "Enter Card Id",
  handleSubmit,
  buttonLabel = "Submit",
  loading = false
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    defaultValues: { userInputtedId: "", cardId: "" },
    reValidateMode: "onChange"
  });
  const { setValue, formState, watch, register } = formMethods;
  const userInputtedId = watch("userInputtedId");
  const field = register("userInputtedId");
  react.useEffect(() => {
    setValue("cardId", stripNonDigits(userInputtedId), {
      shouldValidate: true
    });
  }, [setValue, userInputtedId]);
  const errMsg = formState.errors.cardId ? formatMessage(formState.errors.cardId.message) : formState.errors.cardId;
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: formMethods.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(SearchField, {
    ...field,
    name: "userInputtedId",
    placeholder,
    "data-testid": "InputCardByNumber",
    autoComplete: "off",
    inputMode: "numeric",
    loading,
    buttonProps: {
      type: "submit",
      "data-testid": "submit-card",
      "aria-label": buttonLabel,
      variant: "labelled",
      label: buttonLabel
    },
    helperText: /* @__PURE__ */ react.createElement(forms_ErrorMessage, null, formState.errors.cardId && formState.touchedFields.userInputtedId ? errMsg : null)
  })));
};


/***/ }),

/***/ 18747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69525);
/* harmony import */ var _Context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94693);



const SafetySpace = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div")({
  minWidth: (48 + 4 + 16) * 0.3,
  maxWidth: (48 + 4 + 16) * 0.3
});
const GlobalAppIssueSafetySpace = (delegateProps) => {
  const { hasIssue } = (0,_Context__WEBPACK_IMPORTED_MODULE_1__/* .useGlobalAppIssueContext */ .yp)();
  if (!hasIssue) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SafetySpace, {
    ...delegateProps
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GlobalAppIssueSafetySpace);


/***/ }),

/***/ 72520:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ ClinicianHeaderDetails),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36547);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61800);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14187);
/* harmony import */ var elephant_web_client_utils_useFacility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41075);





const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((theme) => ({
  headerText: {
    color: theme.palette.common.white,
    textAlign: "end"
  }
}));
const ClinicianHeaderDetails = () => {
  var _a;
  const styles = useStyles();
  const { firstName, lastName } = (0,_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .SE)();
  const facilityName = (_a = (0,elephant_web_client_utils_useFacility__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().data) == null ? void 0 : _a.name;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, !!facilityName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    variant: "body2",
    className: styles.headerText
  }, facilityName), firstName && lastName && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    variant: "h5",
    className: styles.headerText
  }, `${firstName} ${lastName}`));
};
const ClinicianHeader = () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
  rightContent: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClinicianHeaderDetails, null)
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClinicianHeader);


/***/ }),

/***/ 95751:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ QrScanner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-webcam@5.0.1_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-webcam/dist/react-webcam.js
var react_webcam = __webpack_require__(44282);
var react_webcam_default = /*#__PURE__*/__webpack_require__.n(react_webcam);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/components/Loading/index.ts
var Loading = __webpack_require__(80103);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
;// CONCATENATED MODULE: ./src/client/components/QrScanner/QrFrame.jsx



const useStyles = (0,makeStyles/* default */.Z)({
  qrContainer: `
      position:  absolute; 
      width:  50%; 
      height:  80%;
  `,
  cropFree: `
      position: absolute;
      z-index: 1;
      display: flex;
      height: 100%;
      width: 100%;
      alignItems: center;
      justifyContent: center;
     `,
  qrCodeCornerIconTopLeft: `
       font-size: 3.5rem;
       position: absolute;
       top: 0; 
       left: 0; 
       transform: matrix(1, 0, 0, -1, 0, 0)
     `,
  qrCodeCornerIconTopRight: `
     font-size: 3.5rem;
     position: absolute;
     top: 0; 
     right: 0; 
     transform: rotate(180deg)
   `,
  qrCodeCornerIconBottomLeft: `
     font-size: 3.5rem;
     position: absolute;
     top: calc(100% - 49px);
      left: 0;
   `,
  qrCodeCornerIconBottomRight: `
    font-size: 3.5rem;
    position: absolute;
    top: calc(100% - 49px);
    right: 0;
    transform: matrix(-1, 0, 0, 1, 0, 0)
 `
});
const QrFrame = () => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.cropFree
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.qrContainer
  }, /* @__PURE__ */ react.createElement(dist_module.QrCodeCornerIcon, {
    className: classes.qrCodeCornerIconTopLeft
  }), /* @__PURE__ */ react.createElement(dist_module.QrCodeCornerIcon, {
    className: classes.qrCodeCornerIconTopRight
  }), /* @__PURE__ */ react.createElement(dist_module.QrCodeCornerIcon, {
    className: classes.qrCodeCornerIconBottomLeft
  }), /* @__PURE__ */ react.createElement(dist_module.QrCodeCornerIcon, {
    className: classes.qrCodeCornerIconBottomRight
  })));
};
/* harmony default export */ const QrScanner_QrFrame = (QrFrame);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
;// CONCATENATED MODULE: ./src/client/components/QrScanner/Box3D.tsx


const DEPTH = 20;
var BoxSide = /* @__PURE__ */ ((BoxSide2) => {
  BoxSide2[BoxSide2["FRONT"] = 0] = "FRONT";
  BoxSide2[BoxSide2["BACK"] = 1] = "BACK";
  return BoxSide2;
})(BoxSide || {});
const Box3D_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)({
  scene: {
    width: ({ width }) => width,
    height: ({ height }) => height,
    perspective: ({ width, height }) => width + height
  },
  cube: {
    width: "100%",
    height: "100%",
    position: "relative",
    transformStyle: "preserve-3d",
    transition: "transform 1s"
  },
  face: {
    position: "absolute",
    background: "#000",
    transition: "opacity 2s"
  },
  left: {
    width: DEPTH,
    height: ({ height }) => height,
    transform: `rotateY(-90deg) translateZ(${DEPTH / 2}px)`
  },
  right: {
    width: DEPTH,
    height: ({ height }) => height,
    transform: ({ width }) => `rotateY(90deg) translateZ(${width - DEPTH / 2}px)`
  },
  front: {
    width: ({ width }) => width,
    height: ({ height }) => height,
    transform: `rotateY(0deg) translateZ(${DEPTH / 2}px)`
  },
  back: {
    width: ({ width }) => width,
    height: ({ height }) => height,
    transform: `rotateY(180deg) translateZ(${DEPTH / 2}px)`
  },
  top: {
    height: DEPTH,
    width: ({ width }) => width,
    transform: `rotateX(90deg) translateZ(${DEPTH / 2}px)`
  },
  bottom: {
    height: DEPTH,
    width: ({ width }) => width,
    transform: ({ height }) => `rotateX(-90deg) translateZ(${height - DEPTH / 2}px)`
  },
  cubeShowFront: {
    transform: `translateZ(-${DEPTH / 2}px) rotateY(0deg)`
  },
  cubeShowBack: {
    transform: `translateZ(-${DEPTH / 2}px) rotateY(-180deg)`
  }
});
const Box3D = (props) => {
  const { front, back, width, height, side } = props;
  const classes = Box3D_useStyles({ width, height });
  const isFront = side === 0 /* FRONT */;
  const isBack = side === 1 /* BACK */;
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.scene
  }, /* @__PURE__ */ react.createElement("div", {
    className: `${classes.cube} ${isFront ? classes.cubeShowFront : classes.cubeShowBack}`
  }, /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.front}`
  }, isFront && (front == null ? void 0 : front())), /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.back}`
  }, isBack && (back == null ? void 0 : back())), /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.right}`
  }), /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.left}`
  }), /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.top}`
  }), /* @__PURE__ */ react.createElement("div", {
    className: `${classes.face} ${classes.bottom}`
  })));
};
Box3D.defaultProps = {
  front: null,
  back: null
};
/* harmony default export */ const QrScanner_Box3D = (Box3D);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash.throttle@4.1.1/node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(30826);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
;// CONCATENATED MODULE: ./src/client/components/QrScanner/QrScanner.tsx










const Container = (0,styled/* default */.Z)(Box/* default */.Z)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  p: 2,
  alignItems: "center",
  position: "relative",
  textAlign: "center",
  width: "100%",
  height: "75%",
  minHeight: "234px",
  minWidth: "396px",
  "& video": {
    background: "#000",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "250px"
    },
    width: "100%",
    objectFit: "fill",
    maxWidth: "428px"
  }
}));
const LoadingOverlay = (0,styled/* default */.Z)(Loading/* default */.Z)(({ theme }) => ({
  height: "100%",
  margin: "0",
  [theme.breakpoints.down("xs")]: {
    marginLeft: theme.spacing(4)
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(8)
  },
  textAlign: "center",
  zIndex: 1,
  color: `${theme.palette.primary.contrastText}`
}));
const ToggleIcon = (0,styled/* default */.Z)(dist_module.ToggleCameraIcon)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    display: "none"
  },
  position: "absolute",
  right: "16px",
  bottom: "16px",
  fontSize: "3em"
}));
const videoConstraints = {
  width: 396,
  height: 234
};
const WebcamWrapper = (0,react.forwardRef)(
  ({ videoConstraints: videoConstraints2, side, ...props }, ref) => {
    return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(QrScanner_QrFrame, null), /* @__PURE__ */ react.createElement((react_webcam_default()), {
      videoConstraints: {
        ...videoConstraints2,
        facingMode: side === BoxSide.FRONT ? "user" : "environment"
      },
      audio: false,
      ...props,
      ref
    }), /* @__PURE__ */ react.createElement(ToggleIcon, null));
  }
);
const QrScanner = (props) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { onCapture, extractDataFromQrCode, isSubmittingViaTextInput } = props;
  const throttledOnCapture = (0,react.useCallback)(
    lodash_throttle_default()(onCapture, 5e3, { trailing: false }),
    [onCapture, (lodash_throttle_default())]
  );
  const webcamRef = (0,react.useRef)(null);
  const [hasMedia, setHasMedia] = (0,react.useState)(false);
  const [isSelfie, setIsSelfie] = (0,react.useState)(window.innerWidth > 900);
  const capture = (0,react.useCallback)(() => {
    var _a;
    const canvasEl = (_a = webcamRef.current) == null ? void 0 : _a.getCanvas();
    if (!canvasEl || isSubmittingViaTextInput) {
      return;
    }
    const canvas = canvasEl.getContext("2d");
    const imageData = canvas.getImageData(
      0,
      0,
      videoConstraints.width,
      videoConstraints.height
    );
    const data = extractDataFromQrCode(imageData);
    if (data) {
      throttledOnCapture(data);
    }
  }, [
    videoConstraints.width,
    videoConstraints.height,
    throttledOnCapture,
    isSubmittingViaTextInput
  ]);
  (0,react.useEffect)(() => {
    if (!hasMedia) {
      return () => {
      };
    }
    const interval = setInterval(capture, 200);
    return function cleanUp() {
      clearInterval(interval);
    };
  }, [capture, hasMedia]);
  (0,react.useEffect)(() => {
    if (!hasMedia) {
      return () => {
      };
    }
    const interval = setInterval(() => {
      dist_default().warning(
        formatMessage({
          id: "qrScanner.interval.warning",
          defaultMessage: "QR code could not be read - please try typing the number instead."
        })
      );
    }, 15e3);
    return () => {
      clearInterval(interval);
    };
  }, [hasMedia, formatMessage]);
  const handleUserMediaError = (0,react.useCallback)(() => {
    dist_default().warning(
      formatMessage({
        id: "qrScanner.webcam.error",
        defaultMessage: "Webcam not found. Please ensure your webcam is working."
      })
    );
  }, [formatMessage]);
  return /* @__PURE__ */ react.createElement(Container, {
    onClick: () => setIsSelfie(!isSelfie)
  }, !hasMedia && /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    position: "fixed"
  }, /* @__PURE__ */ react.createElement(LoadingOverlay, {
    float: true
  })), /* @__PURE__ */ react.createElement(QrScanner_Box3D, {
    side: isSelfie ? BoxSide.FRONT : BoxSide.BACK,
    width: videoConstraints.width,
    height: videoConstraints.height,
    front: () => /* @__PURE__ */ react.createElement(WebcamWrapper, {
      videoConstraints,
      side: BoxSide.FRONT,
      ref: webcamRef,
      onUserMedia: () => setHasMedia(true),
      onUserMediaError: handleUserMediaError,
      mirrored: true
    }),
    back: () => /* @__PURE__ */ react.createElement(WebcamWrapper, {
      videoConstraints,
      side: BoxSide.BACK,
      ref: webcamRef,
      onUserMedia: () => setHasMedia(true),
      onUserMediaError: handleUserMediaError,
      mirrored: false
    })
  }));
};


/***/ }),

/***/ 81222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": () => (/* binding */ linkToNewPatientComplete),
/* harmony export */   "JB": () => (/* binding */ linkToNewCardsRegistrationConfirmed),
/* harmony export */   "NW": () => (/* binding */ linkToNewCardsSendPin),
/* harmony export */   "OF": () => (/* binding */ linkToNewPatient),
/* harmony export */   "Pm": () => (/* binding */ linkToNewPatientDuplicates),
/* harmony export */   "V6": () => (/* binding */ linkToNewCardsActivateCard),
/* harmony export */   "hG": () => (/* binding */ linkToNewCardsShowPin),
/* harmony export */   "pQ": () => (/* binding */ linkToNewPatientStep2),
/* harmony export */   "pX": () => (/* binding */ linkToNewPatientRegistrationPayment)
/* harmony export */ });
/* unused harmony exports linkToNew, linkToNewCards */
function linkToNew() {
  return "/new";
}
function linkToNewPatient() {
  return `${linkToNew()}/patient`;
}
function linkToNewPatientDuplicates() {
  return `${linkToNewPatient()}/duplicates`;
}
function linkToNewPatientStep2() {
  return `${linkToNewPatient()}/step2`;
}
function linkToNewPatientRegistrationPayment() {
  return `${linkToNewPatient()}/registration-payment`;
}
function linkToNewPatientComplete() {
  return `${linkToNewPatient()}/complete`;
}
function linkToNewCards() {
  return `${linkToNew()}/cards`;
}
function linkToNewCardsActivateCard() {
  return `${linkToNewCards()}/activate-card`;
}
function linkToNewCardsRegistrationConfirmed() {
  return `${linkToNewCards()}/registration-confirmed`;
}
function linkToNewCardsSendPin() {
  return `${linkToNewCards()}/send-pin`;
}
function linkToNewCardsShowPin() {
  return `${linkToNewCards()}/show-pin`;
}


/***/ }),

/***/ 29859:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ AddNewPatientTracingSpans),
/* harmony export */   "z": () => (/* binding */ AddNewPatientTracingEvents)
/* harmony export */ });
var AddNewPatientTracingSpans = /* @__PURE__ */ ((AddNewPatientTracingSpans2) => {
  AddNewPatientTracingSpans2["ROOT"] = "addNewPatient";
  AddNewPatientTracingSpans2["PAGE_1"] = "addNewPatient.page1";
  AddNewPatientTracingSpans2["PAGE_1__TERMS_OF_REGISTRATION_MODAL"] = "addNewPatient.page1.termsOfRegistrationModal";
  AddNewPatientTracingSpans2["PAGE_2"] = "addNewPatient.page2";
  AddNewPatientTracingSpans2["PAGE_2__MARKETING_CONSENT_MODAL"] = "addNewPatient.page2.marketingConsentModal";
  AddNewPatientTracingSpans2["PAYMENT_PAGE"] = "addNewPatient.paymentPage";
  AddNewPatientTracingSpans2["PAYMENT_PAGE__SUBMIT"] = "addNewPatient.paymentPage.submit";
  AddNewPatientTracingSpans2["DUPLICATES_PAGE"] = "addNewPatient.duplicatesPage";
  AddNewPatientTracingSpans2["SUBMIT"] = "addNewPatient.submit";
  return AddNewPatientTracingSpans2;
})(AddNewPatientTracingSpans || {});
const AddNewPatientTracingEvents = {
  ["addNewPatient" /* ROOT */]: {
    BEGIN: `${"addNewPatient" /* ROOT */}.begin`
  },
  ["addNewPatient.page1" /* PAGE_1 */]: {
    CONTINUE: `${"addNewPatient.page1" /* PAGE_1 */}.continue`
  },
  ["addNewPatient.page1.termsOfRegistrationModal" /* PAGE_1__TERMS_OF_REGISTRATION_MODAL */]: {
    CONTINUE: `${"addNewPatient.page1.termsOfRegistrationModal" /* PAGE_1__TERMS_OF_REGISTRATION_MODAL */}.continue`,
    CANCEL: `${"addNewPatient.page1.termsOfRegistrationModal" /* PAGE_1__TERMS_OF_REGISTRATION_MODAL */}.cancel`
  },
  ["addNewPatient.duplicatesPage" /* DUPLICATES_PAGE */]: {
    CONTINUE: `${"addNewPatient.duplicatesPage" /* DUPLICATES_PAGE */}.continue`
  },
  ["addNewPatient.page2" /* PAGE_2 */]: {
    CONTINUE: `${"addNewPatient.page2" /* PAGE_2 */}.continue`
  },
  ["addNewPatient.page2.marketingConsentModal" /* PAGE_2__MARKETING_CONSENT_MODAL */]: {
    CONTINUE: `${"addNewPatient.page2.marketingConsentModal" /* PAGE_2__MARKETING_CONSENT_MODAL */}.continue`,
    CANCEL: `${"addNewPatient.page2.marketingConsentModal" /* PAGE_2__MARKETING_CONSENT_MODAL */}.cancel`
  },
  ["addNewPatient.paymentPage" /* PAYMENT_PAGE */]: {
    SKIP: `${"addNewPatient.paymentPage" /* PAYMENT_PAGE */}.skip`
  },
  ["addNewPatient.paymentPage.submit" /* PAYMENT_PAGE__SUBMIT */]: {
    SUCCESS: `${"addNewPatient.paymentPage.submit" /* PAYMENT_PAGE__SUBMIT */}.success`,
    FAILURE: `${"addNewPatient.paymentPage.submit" /* PAYMENT_PAGE__SUBMIT */}.failure`
  },
  ["addNewPatient.submit" /* SUBMIT */]: {
    SUCCESS: `${"addNewPatient.submit" /* SUBMIT */}.success`,
    FAILURE: `${"addNewPatient.submit" /* SUBMIT */}.failure`
  }
};


/***/ })

}]);